import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../assets/img/huddle-frame-quitIcon@3x.png';
import _imports_1 from '../assets/img/huddle-pop@3x.png';
const _hoisted_1 = {
  key: 0,
  class: "huddle-pop-mask"
};
const _hoisted_2 = {
  class: "huddle-pop"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_1 + "\" class=\"huddle-pop-pic\" draggable=\"false\"><p class=\"huddle-pop-txt1\"> 组队加速 </p><p class=\"huddle-pop-txt2\"> 超级会员专属特权 </p><table class=\"huddle-pop-form\"><tr><td class=\"huddle-pop-form-txt1\"> 用户身份 </td><td>年费超级会员</td><td>超级会员</td><td>白金会员</td></tr><tr><td class=\"huddle-pop-form-txt1\"> 组队次数 </td><td class=\"huddle-pop-form-txt2\"> 无限次 </td><td><span class=\"huddle-pop-form-txt2\">20</span>次/天</td><td>无</td></tr></table>", 4);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.isShowVipPop ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: _imports_0,
    class: "huddle-pop-quit",
    draggable: "false",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.quitHuddlePop && _ctx.quitHuddlePop(...args))
  }), _hoisted_3, _ctx.showVip ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "huddle-pop-bt",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.goVip && _ctx.goVip(...args))
  }, " 开通超级会员 ")) : _createCommentVNode("", true)])])) : _createCommentVNode("", true);
}